/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React, { FunctionComponent } from 'react'

import { RadioButtonDefault } from 'ui/designSystem/RadioButton/RadioButtonDefault'
import { RadioButtonDetailed } from 'ui/designSystem/RadioButton/RadioButtonDetailed'
import { BaseRadioProps } from 'ui/designSystem/RadioButton/types'

export const RadioButton: FunctionComponent<BaseRadioProps> = ({
  label,
  disabled = false,
  error = false,
  value,
  collapsed,
  description,
  asset,
  sizing = 'hug',
  variant,
  setValue,
  accessibilityLabel,
}) =>
  variant === 'detailed' ? (
    <RadioButtonDetailed
      label={label}
      disabled={disabled}
      error={error}
      value={value}
      setValue={setValue}
      sizing={collapsed ? 'fill' : sizing}
      collapsed={collapsed}
      description={description ?? null}
      asset={asset ?? null}
      variant={variant}
      accessibilityLabel={accessibilityLabel}
    />
  ) : (
    <RadioButtonDefault
      label={label}
      disabled={disabled}
      error={error}
      value={value}
      setValue={setValue}
      variant={variant}
      sizing="hug"
      accessibilityLabel={accessibilityLabel}
    />
  )
